import { SuccessIcon, WarningIcon } from '@bi-digital/icons';
import { Link } from '@bi-digital/react';
import styles from './result.module.css';

export type ResultProps = {
    id?: string;
    message: string;
    message2?: string;
    link?: string;
    linkText?: string;
    success?: boolean;
};

export const Result = ({ id, message, link, linkText, success = false, message2 }: ResultProps) => {
    return (
        <div id={id} className={styles.resultComponent} role={success ? 'status' : 'alert'}>
            {success ? (
                <SuccessIcon aria-hidden={true} className={styles.success} />
            ) : (
                <WarningIcon aria-hidden={true} />
            )}
            <p>
                <span>{message}</span>
                {message2 && <span>{message2}</span>}
                {link && (
                    <>
                        <br />
                        <Link href={link}>{linkText}</Link>
                    </>
                )}
            </p>
        </div>
    );
};
